module.exports = __webpack_public_path__ + "static/media/consultoria3.227f0d8a.jpg";